import React, {useEffect, useState} from "react";
import "./FadeIn.css"; // CSSファイルを作成

export const FadeInBody = ({children}) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // マウント後に少し遅らせて `visible` を `true` に変更
    const timer = setTimeout(() => setVisible(true), 10);
    return () => clearTimeout(timer); // クリーンアップ
  }, []);

  return <div className={`fade-in ${visible ? "visible" : ""}`}>{children}</div>;
};
